import React from 'react';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './CompanySelectionListItem.module.css';

export class CompanySelectionListItem extends React.Component {
    render() {
        return (
            <div className={styles.company_div}>
                <button
                    className={styles.company_button}
                    onClick={() => this.props.selectCompany(this.props.id)}>
                    <FontAwesomeIcon icon={faCaretRight} transform="grow-6" color="white" />
                </button>
                <label>{this.props.name}</label>
            </div>
        );
    }
}


